// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import styled from 'styled-components';

import StyledImg from '@ecp/common/src/components/image/StyledImg';

import { MainContentsBox } from '@fo-components/common/styled';

const Wrapper = styled(MainContentsBox)`
  height: 50px;
  justify-content: space-between;
  min-width: 950px;
`;

const Logo = styled(StyledImg)`
  max-height: 50px;
  margin-right: ${(props) => props.theme.component.gnb.logo.marginRight};
`;

const ShortcutButton = styled.div`
  width: 238px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 2px solid ${(props) => props.theme.color.primary};
  border-radius: 34px;
  color: ${(props) => props.theme.color.text.basic};
`;

const LoginButton = styled.div`
  width: 112px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 2px solid ${(props) => props.theme.color.primary};
  border-radius: 34px;
  color: ${(props) => props.theme.color.text.basic};
  font-weight: 400;
  font-size: 14px;
`;

export { Wrapper, Logo, ShortcutButton, LoginButton };
